import classnames from 'classnames';
import { isNil } from 'ramda';
import React, { FC } from 'react';
import { useBoolean } from '../../../../utils/hooks/useBoolean';
import { IconButton } from '../../../../components/common';
import { ChevronDownSmall, ChevronUpSmall } from '../../../../components/common/WixIcons';
import styles from './PanelSection.scss';
import { IOuter } from './PanelSection.types';
import { useMMGRSettings } from '../../../../utils/hoc/withMMGRSettings';

export const PanelSection: FC<IOuter> = ({ header, collapsed, children, dataHook }) => {
  const {
    mmgrSettings: { isUIAlignmentsEnabled },
  } = useMMGRSettings();
  const { value: isCollapsed, toggle: toggleCollapsed } = useBoolean(collapsed);
  const isCollapsible = !isNil(collapsed);

  return (
    <div className={classnames(isCollapsible && styles.collapsible, isCollapsed && styles.collapsed)}>
      <div
        className={classnames(styles.header, {
          [styles.new]: isUIAlignmentsEnabled,
        })}
        onClick={toggleCollapsed}
        role="button"
        data-hook={dataHook}
      >
        {header}

        {isCollapsible && (
          <IconButton size="tiny" skin="standard" priority="secondary">
            {isCollapsed ? <ChevronDownSmall /> : <ChevronUpSmall />}
          </IconButton>
        )}
      </div>

      <div className={styles.contentWrapper}>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};
